import { isRetailCashierPath } from "./app";
import { TOKO_EMBED_AUTH_MESSAGE_TYPE, isTrustedEmbedParentOrigin } from "./config";
import { isOAuthCallbackPath } from "./oauthStart";
import { mountOAuthCallback } from "./oauthCallback";
import { installTauriApiFetchProxy } from "./tauriApiFetch";

installTauriApiFetchProxy();

const root = document.querySelector("#app") as HTMLElement | null;
if (!root) {
  throw new Error("#app missing");
}

/**
 * Parent iframe may post auth as soon as the frame fires `load`, before the
 * async POS chunk runs and `waitForEmbedBearer` attaches.
 * Buffer the token here so the POS shell never misses the first message.
 */
function installEarlyEmbedAuthMessageListener(): void {
  window.addEventListener("message", (e: MessageEvent) => {
    if (typeof e.origin !== "string" || !isTrustedEmbedParentOrigin(e.origin)) {
      return;
    }
    const d = e.data as { type?: string; authToken?: string } | null;
    if (
      d?.type === TOKO_EMBED_AUTH_MESSAGE_TYPE &&
      typeof d.authToken === "string" &&
      d.authToken.length > 0
    ) {
      window.__TOKO_POS_EMBED_BEARER__ = d.authToken;
    }
  });
}

if (isOAuthCallbackPath()) {
  void mountOAuthCallback(root);
} else if (isRetailCashierPath()) {
  /** Cancels landing-page `#app` / `body` chrome from `styles.css` so POS fills the iframe. */
  document.documentElement.classList.add("toko-umag--retail-pos");
  installEarlyEmbedAuthMessageListener();
  void import("./umag/mount").then((m) => void m.mountUmagCashier(root));
} else {
  document.documentElement.classList.add("toko-umag--landing");
  void import("./umag/landing/mountLanding").then((m) => m.mountLanding(root));
}
